module.exports = __webpack_public_path__ + "static/img/A153.4a872cb4.jpg";